import { TypoCat } from '@bangle.io/ui-components';
import React from 'react';

/** Default empty-state illustration — Typo napping. */
export function EmptyStateIllustration() {
  return (
    <TypoCat pose="napping" className="h-28 w-auto opacity-90" decorative />
  );
}
